<template>
  <main>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.editTeacher") }}</h3>
          </template>

          <template #right-element>
            <a class="btn btn-outline-primary button" @click="$router.go(-1)" :disabled="loading">
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </a>
          </template>
        </TopTemplate>
        <div>
          <form class="add-teacher" novalidate @submit.prevent="onSubmitCreateTeacher">
            <div class="general-info">
              <div class="accordSid" @click="toggleAccInfo()">
                <h3>{{ $t("title.infoGeneral") }}</h3>
                <div class="icons-wrapper">
                  <i v-if="show1" class="icon-Minus color-green" />
                  <i v-else class="icon-Add color-green" />
                </div>
              </div>

              <div v-if="show1" class="panel">
                <div class="row align-items-center">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("teacher.form.firstName") }}
                            <sup>*</sup>
                          </label>
                          <div>
                            <input v-model="getTeacher.first_name" type="text" class="form-control" :class="{'is-invalid': v$.getTeacher.first_name.$error}" />
                            <span v-if="v$.getTeacher.first_name.$error" class="invalid-feedback">
                              {{ v$.getTeacher.first_name.$errors[0].$message }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("teacher.form.lastName") }}
                            <sup>*</sup>
                          </label>
                          <div>
                            <input v-model="getTeacher.last_name" type="text" class="form-control" :class="{'is-invalid': v$.getTeacher.last_name.$error}" />
                            <span v-if="v$.getTeacher.last_name.$error" class="invalid-feedback">
                              {{ v$.getTeacher.last_name.$errors[0].$message }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-123">
                        <div class="simple-input">
                          <label class="label"> {{ $t("teacher.form.phone") }} <sup>*</sup></label>
                          <div>
                            <input
                              v-model="getTeacher.phone"
                              class="form-control"
                              @input="formatPhoneNumber"
                              :class="{
                                'is-invalid': v$.getTeacher.phone.$error || (!validNumber && isValidate),
                              }"
                            />
                            <span v-if="phoneExists" class="invalid-champ"> Ce numéro de téléphone existe déjà !</span>

                            <span v-if="v$.getTeacher.phone.$error" class="invalid-feedback">
                              {{ v$.getTeacher.phone.$errors[0].$message }}
                            </span>
                            <span v-if="!validNumber && isValidate && !v$.getTeacher.phone.$error" class="invalid-feedback">{{ $t("validation.isPhone") }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("teacher.form.email") }}
                          </label>
                          <div>
                            <input v-model="getTeacher.email" type="email" class="form-control" :class="{'is-invalid': v$.getTeacher.email.$error}" />
                            <span v-if="emailExists" class="invalid-champ">{{ $t("common.mail_exist") }}</span>
                            <span v-if="v$.getTeacher.email.$error" class="invalid-feedback">{{ v$.getTeacher.email.email.$message }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("teacher.form.address") }}
                          </label>
                          <div>
                            <input v-model="getTeacher.address" type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12 simple-input">
                        <label class="label">{{ $t("teacher.form.emploi") }}</label>
                        <label class="input-image" for="otherDoc" @change="onFileChange">
                          <div class="file-name">
                            <span class="justify--" v-if="getTeacher.timetable_name">
                              {{ getTeacher.timetable_name }}
                            </span>
                            <span class="justify--- err article" v-else>
                              {{ $t("info.downloadDocs") }}
                            </span>
                          </div>
                          <div class="icon-upload">
                            <img src="../../assets/icons/VectorMsg.svg" />
                          </div>
                          <input id="otherDoc" type="file" class="d-none" accept=".pdf" tabindex="-1" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="general-info duplicator">
              <div class="accordSid" @click="toggleAccNiv()">
                <h3>{{ $t("title.selectClasses") }}</h3>
                <div class="icons-wrapper">
                  <i v-if="show2" class="icon-Minus color-green" />
                  <i v-else class="icon-Add color-green" />
                </div>
              </div>

              <div v-if="show2" class="panel">
                <div v-for="(item, index) in getTeacher.classes" :key="index" class="row align-items-center duplicator__ex">
                  <div :class="existRemove ? 'col-xl-5' : 'col-xl-6'">
                    <div class="simple-input simple-select">
                      <label class="label">
                        {{ $t("teacher.form.class") }}
                      </label>
                      <v-select
                        v-model="item.id_class"
                        :options="comptedFilterClasses"
                        :searchable="true"
                        label="name"
                        class="form-control"
                        :reduce="(option) => option.id"
                        :scrollable="true"
                        @update:modelValue="ChangeClass($event, index)"
                      >
                        <template #no-options="{search, searching, loading}">
                          <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                            {{ $t("common.emptysearchClasse") }}
                          </div>
                          <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                            <div class="spinner-border text-info" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div :class="existRemove ? 'col-xl-5' : 'col-xl-6'">
                    <div class="simple-input simple-select selct-multip">
                      <label class="label">
                        {{ $t("teacher.form.courses") }}
                      </label>
                      <v-select
                        v-model="item.courses"
                        :options="computedCourses[index]"
                        :searchable="true"
                        label="name"
                        class="form-control"
                        :reduce="(option) => option.id"
                        :scrollable="true"
                        multiple
                        :class="{disabled: !item.id_class}"
                        :disabled="!item.id_class"
                      >
                        <template #no-options="{loading}">
                          <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                            {{ $t("common.emptysearchCourse") }}
                          </div>
                          <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                            <div class="spinner-border text-info" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="simple-input last-input-modif col-md-3 col-5">
                    <div class="buttons-wrapper">
                      <i v-if="getTeacher.classes.length > 1" class="icon-trash" @click="actionTable(index, 'remove')" />
                    </div>
                  </div>
                  <div v-if="index === getTeacher.classes.length - 1" class="col-md-12 btn-add">
                    <button class="btn button btn-primary" @click="actionTable(index, 'add')"><i class="icon-Add" /> {{ $t("button.add") }}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 buttons">
              <div class="button-right d-flex justify-content-end mb-4">
                <button type="submit" class="btn button btn-primary" :disabled="isSubmitted">
                  <i class="icon-Check" />
                  {{ $t("button.envoi") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import useValidate from "@vuelidate/core";
import {required, helpers, email} from "@vuelidate/validators";
import {parsePhoneNumberFromString, isValidNumber} from "libphonenumber-js";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "EditTeacher",
  components: {
    TopTemplate,
    "v-select": vSelect,
  },
  setup() {
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/0${month}/${year}`;
      } else if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };
    return {
      format,
    };
  },
  data() {
    return {
      v$: useValidate(),
      validNumber: false,
      teacherId: null,
      phoneExists: false,
      emailExists: false,
      existRemove: false,
      loading: true,
      disabled: true,
      show1: true,
      show2: true,
      is_created: false,
      isValidate: false,
      isSubmitted: false,
    };
  },
  validations() {
    return {
      getTeacher: {
        first_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        last_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        email: {
          email: helpers.withMessage(this.$t("validation.email"), email),
        },
        phone: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  created() {
    this.teacherId = this.$route.params.id;
  },
  mounted() {
    this.handleData();
  },
  computed: {
    ...mapGetters(["getTeacher", "geFilterTeacher"]),
    comptedFilterClasses() {
      return _.orderBy(this.geFilterTeacher.classes, "name");
    },
    computedCourses() {
      return this.getTeacher?.classes?.map((item) => this.comptedFilterClasses?.find((x) => x.id === item.id_class)?.courses) || [];
    },
  },
  methods: {
    ...mapActions(["getTeacherById", "getFiltreTeacher", "updateTeacherStore"]),
    onFileChange(e) {
      const file = e.target.files[0];
      this.getTeacher.timetable_name = file.name || null;
      this.getTeacher.timetable = file;
    },
    formatPhone(value) {
      const phoneNumber = parsePhoneNumberFromString(value, "TN");
      return phoneNumber ? phoneNumber.formatNational() : "";
    },
    formatPhoneNumber() {
      const phoneNumber = parsePhoneNumberFromString(this.getTeacher.phone, "TN");
      if (this.getTeacher.phone) {
        if (!phoneNumber) {
          this.validNumber = false;
          return;
        }
        this.validNumber = isValidNumber(phoneNumber.number);
        this.getTeacher.phone = phoneNumber ? phoneNumber.formatNational() : "";
      }
    },
    toggleAccInfo() {
      this.show1 = !this.show1;
    },
    toggleAccNiv() {
      this.show2 = !this.show2;
    },

    actionTable(classIndex, actionType) {
      actionType === "remove" ? this.getTeacher.classes.splice(classIndex, 1) : this.getTeacher.classes.push({id_class: null, name: null, courses: []});
      this.existRemove = actionType === "remove" ? !this.getTeacher.classes.length : true;
    },
    async handleData() {
      await this.getFiltreTeacher();
      const response = await this.getTeacherById(this.teacherId);
      if (response) {
        this.getTeacher.phone = this.formatPhone(this.getTeacher.phone);
        this.formatPhoneNumber();
        this.existRemove = this.getTeacher.classes.length > 1 ?? true;
        this.loading = false;
      }
    },

    ChangeClass(e, i) {
      this.getTeacher.classes[i].courses = [];
      if (e) {
        this.computedCourses[i] = this.comptedFilterClasses.find((x) => x.id === e)?.courses;
      }
    },

    async onSubmitCreateTeacher() {
      this.isValidate = true;
      this.v$.$validate();
      this.show1 = true;
      this.show2 = true;
      this.$nextTick(() => {
        if (document.querySelector(".is-invalid")) {
          let domRect = document.querySelector(".is-invalid").getBoundingClientRect();
          window.scrollTo({
            left: domRect.left + document.documentElement.scrollLeft,
            top: domRect.top + document.documentElement.scrollTop - 90,
            behavior: "smooth",
          });
        }
        return;
      });
      if (!this.v$.$error && this.validNumber) {
        this.isSubmitted = true;
        const fields = ["first_name", "last_name", "address", "phone", "email", "classes", "timetable"];
        let formData = new FormData();
        fields.map((key) => {
  switch (key) {
    case "classes":
      const classes = this.getTeacher.classes.map((classe) => {
        return {
          ...classe,
          courses: classe.courses.map((item) => this.geFilterTeacher.courses.find((course) => course.id === item)),
        };
      });
      
      formData.append(key, JSON.stringify(classes));
      break;

    case "phone":
      formData.append(key, this.getTeacher.phone.replace(/ /g, ""));
      break;

    case "email":
      formData.append(key, this.getTeacher.email || "");
      break;

    case "address":
      formData.append(key, this.getTeacher.address || "");
      break;

    default:
      formData.append(key, this.getTeacher[key]);
      break;
  }
});

        const response = await this.updateTeacherStore({
          id: this.teacherId,
          payload: formData,
        });
        this.isSubmitted = false;
        this.loading = false;
        if (response.success) {
          this.$router.push({
            name: "DetailTeacher",
            params: {id: this.teacherId},
          });
        } else {
          if (this.getTeacher.classes.length === 0) {
            this.getTeacher.classes.push({
              courses: [],
              id_class: null,
              id_course: [],
            });
          }
          this.phoneExists = response?.errors?.phone ?? false;
          this.emailExists = response?.errors?.email ?? false;
        }
        this.scrollToTop();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style>
.invalid-champ {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
</style>
